import { isDraggableGrid } from '../api/config';
import { customLayouts } from '../custom/helpers/layout';

export interface LayoutGridGeneralInterface {
    x: number;
    y: number;
    w: number;
    h: number;
    i: string;
}

export interface LayoutGrid {
    lg: LayoutGridGeneralInterface[];
    md: LayoutGridGeneralInterface[];
    sm: LayoutGridGeneralInterface[];
}

export const getStaticHeight = () => {
    const header = document.getElementsByTagName('header')[0];
    const headerHeight = header ? header.clientHeight : 0;
    const headerContainer = document.getElementsByClassName('pg-trading-header-container')[0];
    const headerContainerHeight = headerContainer ? headerContainer.clientHeight : 0;

    return headerHeight + headerContainerHeight;
};

export const gridUnitsToPixels = (gridUnit: number, rowHeight: number, margin: number) => {
    let res = gridUnit * (rowHeight + margin);
    if (gridUnit > 1) {
        res -= margin;
    }

    return res;
};

export const pixelsToGridUnits = (pixels: number, rowHeight: number, margin: number) => {
    let tmp = pixels;

    if (pixels / (rowHeight + margin) > 1) {
        tmp += margin;
    }

    return tmp / (rowHeight + margin);
};

const getLayouts = () => {
    const rowHeight = 14;
    const margin = 6;

    const orderHeight = 12;
    const minTradingChartHeight = 10;
    const minOrderBookHeight = 10;
    const minRecentTradesHeight = 10;
    const minOpenOrdersHeight = 11.5;
    const staticHeight = getStaticHeight() || 96;
    const isDraggable = isDraggableGrid();
    // const isResizable = isResizableGrid();

    const minGridHeight =
        gridUnitsToPixels(minTradingChartHeight, rowHeight, margin) +
        gridUnitsToPixels(minOpenOrdersHeight, rowHeight, margin) +
        margin * 3;
    const gridHeight = Math.max(minGridHeight, window.innerHeight - staticHeight - margin * 3);

    const currentTradingChartHeight = pixelsToGridUnits(
        gridHeight - margin * 2 - gridUnitsToPixels(orderHeight, rowHeight, margin),
        rowHeight,
        margin,
    );
    const tradingChartHeight =
        gridHeight >= minGridHeight
            ? currentTradingChartHeight + margin * 0.67
            : Math.floor(Math.max(currentTradingChartHeight, minTradingChartHeight));

    const currentorderBookHeight = pixelsToGridUnits(
        gridHeight - margin * 2 - gridUnitsToPixels(orderHeight, rowHeight, margin),
        rowHeight,
        margin,
    );
    const orderBookHeight =
        gridHeight >= minGridHeight
            ? currentorderBookHeight + margin * 0.67
            : Math.floor(Math.max(currentorderBookHeight, minTradingChartHeight));
    const openOrdersHeight = 12;

    // const orderBookHeight = 34.2
    const toobarHeight = 3;
    const recentTradesHeight =
        gridHeight >= minGridHeight
            ? pixelsToGridUnits(gridHeight - margin, rowHeight, margin) + margin - 3.3
            : minRecentTradesHeight;
    return {
        lg: [
            {
                x: 0,
                y: 0,
                w: 24,
                h: 2.5,
                i: '5',
                minH: 2,
                minW: 4,
                isDraggable: isDraggable,
                isResizable: false,
            },
            {
                x: 0,
                y: 1,
                w: 24,
                h: 24,
                i: '2',
                minH: 10,
                minW: 5,
                isDraggable: isDraggable,
                isResizable: false,
            },

        ],
        md: [
            {
                x: 0,
                y: 0,
                w: 24,
                h: 2.5,
                i: '5',
                minH: 2,
                minW: 4,
                isDraggable: isDraggable,
                isResizable: false,
            },
            {
                x: 0,
                y: 1,
                w: 24,
                h: 24,
                i: '2',
                minH: 10,
                minW: 5,
                isDraggable: isDraggable,
                isResizable: false,
            },

        ],
        sm: [
            {
                x: 0,
                y: 0,
                w: 24,
                h: 2.5,
                i: '5',
                minH: 2,
                minW: 4,
                isDraggable: isDraggable,
                isResizable: false,
            },
            {
                x: 0,
                y: 1,
                w: 24,
                h: 24,
                i: '2',
                minH: 10,
                minW: 5,
                isDraggable: isDraggable,
                isResizable: false,
            },

        ],
        ...customLayouts,
    };
};

export const layouts = getLayouts();

export const getLayoutFromLS = (key: string): LayoutGrid | undefined => {
    let obj: any = {};
    if (localStorage) {
        try {
            obj = JSON.parse(localStorage.getItem('rgl') || '') || {};
        } catch (e) {
            // ignore
        }
    }

    return obj[key];
};

export const saveLayoutToLS = (key: string, value: any): void => {
    if (localStorage) {
        localStorage.setItem('rgl', JSON.stringify({ [key]: value }));
    }
};

export const resetLayout = (key: string): void => {
    if (localStorage) {
        localStorage.setItem('rgl', JSON.stringify({ [key]: layouts }));
    }
};
